// VehicleService.tsx
import { BaseService } from '../../core/BaseService';
import { ChangeStatusRequest, PaginationParams } from '../../type';
import {
  ChangeStatusVehicleResponse,
  DeleteVehicleResponse,
  GetBookingsResponse,
  GetModelEnginesByModelResponse,
  GetModelsByMakeResponse,
  GetServiceHistoryResponse,
  GetServiceRecommendationsResponse,
  GetVehicleByIdResponse,
  GetVehicleByVinResponse,
  GetVehicleInspectionByIdResponse,
  GetVehicleResponse,
  VehicleRequest,
  VehicleResponse,
} from './interface';

export class VehicleProfile extends BaseService {
  async createVehicle(req: VehicleRequest) {
    return this.post<VehicleResponse, VehicleRequest>(`${this.apiUrl}/api/vehicles`, req);
  }

  async getVehicle(params: PaginationParams) {
    return this.get<GetVehicleResponse>(`${this.apiUrl}/api/vehicles/paged`, params);
  }

  async updateVehicle(id: number, req: VehicleRequest) {
    return this.put<VehicleResponse, VehicleRequest>(`${this.apiUrl}/api/vehicles/${id}`, req);
  }

  async deleteVehicle(id: number) {
    return this.delete<DeleteVehicleResponse>(`${this.apiUrl}/api/vehicles/${id}`);
  }

  async changeStatusVehicle(id: number, active: string, req: ChangeStatusRequest) {
    return this.put<ChangeStatusVehicleResponse, ChangeStatusRequest>(
      `${this.apiUrl}/api/vehicles/${active}/${id}`,
      req
    );
  }

  async getModelsByMake(params: PaginationParams, id: number) {
    return this.get<GetModelsByMakeResponse>(`${this.apiUrl}/api/models/bymakeid/${id}`, params);
  }

  async getModelEnginesByModel(params: PaginationParams, id: number) {
    return this.get<GetModelEnginesByModelResponse>(`${this.apiUrl}/api/modelengines/bymodelid/${id}`, params);
  }

  async getVehicleByID(id: number) {
    return this.get<GetVehicleByIdResponse>(`${this.apiUrl}/api/vehicles/${id}`);
  }

  async getVehiclesDropdown(params: PaginationParams) {
    return this.get<GetVehicleResponse>(`${this.apiUrl}/api/vehicles/get`, params);
  }

  async getBookings(params: PaginationParams) {
    return this.get<GetBookingsResponse>(`${this.apiUrl}/api/bookings/paged`, params);
  }

  async getVehicleInspections(params: PaginationParams) {
    return this.get<GetBookingsResponse>(`${this.apiUrl}/api/vehicleinspectionforms/paged`, params);
  }

  async getVehicleServiceRecommendations(params: PaginationParams) {
    return this.get<GetServiceRecommendationsResponse>(`${this.apiUrl}/api/maintenances/paged`, params);
  }

  async getVehicleServiceHistory(params: PaginationParams) {
    return this.get<GetServiceHistoryResponse>(
      `${this.apiUrl}/api/services/servicehistory/${params?.vehicleId}`,
      params
    );
  }

  async getVehicleByVin(vin: string) {
    return this.get<GetVehicleByVinResponse>(`${this.apiUrl}/api/vehicles/vin/${vin}`);
  }

  async getVehicleInspectionByID(id: number) {
    return this.get<GetVehicleInspectionByIdResponse>(`${this.apiUrl}/api/vehicleinspectionforms/detail/${id}`);
  }
}
